// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1_lRM","cls2":"ContentFeedback-cls2_QJy ContentFeedback-cls1_lRM"};